import { OperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.dto'
import { TranslationResponse } from '@/api/services/common.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface LaboratoryProcessModalState {
    id: StrictNullable<number>
    operation: StrictNullable<OperationResponse>
    order: number | string
    nameTranslations: TranslationResponse[]
    laboratoryId: number
}
export const initialLaboratoryProcessModalState =
    (): LaboratoryProcessModalState => ({
        id: null,
        operation: null,
        order: '',
        nameTranslations: [],
        laboratoryId: store.getters.labId
    })
